/**
 * Root (<html>) classes that drive the docked assistant panel's #app reflow.
 *
 * Shared because two components must agree on them: GlobalChatbotContainer TOGGLES
 * them, and App.vue READS them to decide whether #app is currently narrowed (and so
 * whether its own width is the layout width or the viewport width). A duplicated
 * string literal here silently breaks canvas sizing, so keep it in one place.
 */

/** On <html> while the docked panel is expanded; shrinks #app by the panel width. */
export const DOCKED_HTML_CLASS = 'ai-assistant-docked'

/** On <html> only for the duration of the open/close width transition. */
export const DOCKING_HTML_CLASS = 'ai-assistant-docking'

export default { DOCKED_HTML_CLASS, DOCKING_HTML_CLASS }
